import { useCallback } from 'react';
import { useTranslation as useReactI18nextTranslation } from 'react-i18next';

import { createTranslator } from './customT';

/**
 * Override the default useTranslation hook to provide a custom implementation.
 * This is done to ensure the dynamic values in the translation strings are
 * correctly rendered as React components or strings.
 *
 * This is needed because our translations provider SmartCat only supports
 * dynamic values as strings, and we want to support React components as well.
 *
 * Dynamic components are supported by i18next using html markup, but this is
 * not supported by SmartCat. Therefore, we need to override the useTranslation
 * hook to provide a custom implementation that can handle React components.
 */
export function useTranslation(namespace?: string | string[]) {
  const { t, ...rest } = useReactI18nextTranslation(namespace);
  const customT = useCallback(createTranslator(t), [t]);

  return { t: customT, ...rest };
}
